import {secured as axios} from "../../../axios";

export class UserInfo {
    static async getUserInfo() {
        const res = await axios.get(`/user-info`);
        return res.data;
    }

    static async getRole() {
        const res = await axios.get(`/user-roles`);
        return res.data;
    }
}
